import useBasePageQuery from './useBasePageQuery';

export function useAverageDonation(): number {
  const { data: basePageData } = useBasePageQuery();

  const donationValue =
    basePageData?.page?.donationSummary?.onlineAmount?.value;
  const donationCount =
    basePageData?.page?.donationSummary?.onlineDonationCount || 0;
  if (donationCount < 5) return 0;
  const avgDonation = Math.round((donationValue / donationCount / 1000) * 10);

  return avgDonation;
}
